export enum WorkflowVariables {
  _bokuFlow_workflowResultProtocolJSON = '_bokuFlow_workflowResultProtocolJSON',
  _bokuFlow_assigneeTerm = '_bokuFlow_assigneeTerm',
  _bokuFlow_workflowResult = '_bokuFlow_workflowResult',
  hasBeenCancelledByFullname = 'hasBeenCancelledByFullname',
  hasBeenCancelledComment = 'hasBeenCancelledComment',
}
